// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jUZC","checkbox":"styles_checkbox__u2xcU","label":"styles_label__3JFpE"};